<template>
    <div class="contact-address">
        <ul>
            <li class="contact-address-headline">{{ title }}</li>
            <li v-for="(line, i) in descriptionList" :key="i">
                {{ line }}
            </li>
            <li><a :href="`mailto:${email}`">{{ email }}</a></li>
        </ul>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            default: 'Our Office'
        },
        descriptionList: {
            type: Array,
        },
        email: {
            type: String,
        },
        socialMediaList: {
            type: Array,
        }
    },
}
</script>